onComplete(function() {
	// Fade-in van secties bij het in beeld scrollen, zoals de oude site.
	var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	var editing = document.body.getAttribute('data-editor-mode') === 'content';
	if (reduceMotion || editing || !('IntersectionObserver' in window)) {
		return;
	}

	// Secties die al (deels) in beeld staan niet verbergen: de bezoeker ziet ze
	// al, dus verdwijnen en opnieuw infaden oogt als een fout.
	var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
	var targets = Array.prototype.filter.call(document.querySelectorAll('#content section'), function(section) {
		return section.getBoundingClientRect().top >= viewportHeight;
	});
	if (!targets.length) {
		return;
	}

	targets.forEach(function(section) {
		section.classList.add('js-fade');
	});

	// Drempel in pixels (via rootMargin) in plaats van een percentage van de
	// sectie: bij een hoge sectie, zoals een fotogalerij van vele schermhoogtes,
	// past een percentage soms nooit tegelijk in beeld en blijft hij onzichtbaar.
	var observer = new IntersectionObserver(function(entries) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting) {
				entry.target.classList.add('is-visible');
				observer.unobserve(entry.target);
			}
		});
	}, {
		threshold: 0,
		rootMargin: '0px 0px -80px 0px',
	});

	targets.forEach(function(section) {
		observer.observe(section);
	});
});
